export default "__VITE_ASSET__DD9ezqKP__"